import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DxScrollViewModule } from 'devextreme-angular';
import { TermsAndConditionsModalComponent } from './components/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { ViewTermsAndConditionsModalComponent } from './components/view-terms-and-conditions-modal/view-terms-and-conditions-modal.component';
import { Ng2PdfViewerComponent } from '../ng2-pdf-viewer/ng2-pdf-viewer.component';

@NgModule({
  declarations: [TermsAndConditionsModalComponent, ViewTermsAndConditionsModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    DxScrollViewModule,
    Ng2PdfViewerComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [TermsAndConditionsModalComponent, ViewTermsAndConditionsModalComponent],
})
export class CoreTermsAndConditionsModule {}
